<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<v-menu v-model="menuVisible"
		:close-on-content-click="false"
		offset-x>

		<template v-slot:activator="{ on }">
			<v-btn class="ml-3" color="primary" dark v-on="on">
				<v-icon>list</v-icon>
				Ustawienia kolumn
			</v-btn>
		</template>

		<v-card class="pa-3">
			<v-layout wrap style="width: 800px;">
				<v-flex xs3 v-for="(column, index) in columns" :key="index">
					<v-checkbox
						aria-label="column text"
						:label="column.text"
						v-model="columnVisibility[column.value]"
						@change="$emit('column-toggled', column.value, columnVisibility[column.value])"
					></v-checkbox>
				</v-flex>
			</v-layout>
		</v-card>
	</v-menu>
</template>
<script>
	export default {
		name: "hideable-columns-menu",

		data() {
			return {
				menuVisible: false,
				columnVisibility: null,
			};
		},

		watch: {
			columns(newVal) {
				if (this.columnVisibility === null) {
					this.columnVisibility = newVal
						.reduce((obj, c) => {
							obj[c.value] = true;
							return obj;
						}, {});
				}
			},
			columnVisibilities(newVal) {
				this.columnVisibility = newVal;
			},
		},

		props: {
			columns: {type: Array, required: true, default: () => []},
			columnVisibilities: {required: true},
		},
	};
</script>


<style scoped>

</style>